module.exports = __webpack_public_path__ + "static/media/scanopro-1.a0521185.jpg";